import { ViewModel,View, ObservableArray, ViewModelMessage } from "binder"
import { CurrentCredentials } from "src/server/currentCredentials";
import { ServerConnection } from "src/server/serverConnection";
import { SideBarItem } from "src/uicomponents/components/sidebar/sidebar-viewModel";
import { SidebarItemView } from "src/uicomponents/components/sidebar/sidebarItem/sidebarItem-view";
import { MediaSelector } from "uicomponents";
import { ThemeSelectorViewModel } from "../themeSelector/themeSelector-viewModel";
import { stringIsNullOrEmpty } from "../utilities";
import { WindowFactory } from "../windowFactory";
import  { UserMainWindowView } from "./userMainWindow-view"
import { UserMainWindowPhoneView } from "./userMainWindowPhone/userMainWindowPhone-view";
import { RequestCloseWindowMessage, WindowContainerViewModel, WindowViewModel } from "./windowContainer/windowContainer-viewModel";
import { ShowMessageBoxMessage } from "src/binder/uiPatterns/mvvm/viewmodel";
import { RegisterForServerNotification, ServerNotification } from "src/server/serverNotification";
declare var Lobibox;

export class UserMainWindowViewModel extends ViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.autohide = false;
        this.forms = ObservableArray.create<WindowContainerViewModel>();
        this.filter = new FilterAccessibleFormsViewModel(this);
        this.loggedInPersonnelName = CurrentCredentials.personnelFullName;
        this.loggedInPersonnelCode = CurrentCredentials.personnelCode;
        this.serverNotification = new ServerNotification(()=>CurrentCredentials.username,()=>CurrentCredentials.password);
        this.serverNotification.handleMessage(new RegisterForServerNotification("NewNotification",(x,y)=>{
            let msg = <any>y;
            let alertType = msg.AlertType;
            let type = '';
            let icon ='';
            switch(alertType){
                case 1: 
                    type = 'success';
                    icon = 'notification-success';
                    break;
                case 2: 
                    type = 'info';
                    icon = 'notification-information';
                    break;
                case 3: 
                    type = 'warning';
                    icon = 'notification-warning';
                    break;
                case 4: 
                    type = 'error';
                    icon = 'notification-error';
                    break;
            }

            Lobibox.notify(type, {
                pauseDelayOnHover:true,
                continueDelayOnInactiveTab: false,
                title:msg.Title,
                msg: msg.Body,
                delay : 1000000,
                messageHeight:'auto',
                icon: `bi ${icon}`,

            });
        }))
    }
    
    GetDefaultView(): View <ViewModel> {
        return MediaSelector.GetView({
            default : ()=>new UserMainWindowView(),
            portraitPhone : ()=> new UserMainWindowPhoneView(),
            landscapePhone : ()=> new UserMainWindowPhoneView(),
        });
    }
    public getTypeId(): string {
        return "VM-15D1595C-4B19-4E39-B4C5-FB4DEB2023AA"
    }
    private serverNotification: ServerNotification;

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set forms(v: ObservableArray<WindowContainerViewModel>) { this._forms = v; } public get forms(): ObservableArray<WindowContainerViewModel> { return this._forms;} private _forms: ObservableArray<WindowContainerViewModel>;
    public set currentForm(v: WindowContainerViewModel) { 
        this._currentForm = v; 
        if(v?.window?.isShowingPopup == true){
            v.window.isShowingPopup = false;
            setTimeout(()=>{
                v.window.isShowingPopup = true;
            },100)
        }
    } public get currentForm(): WindowContainerViewModel { return this._currentForm;} private _currentForm: WindowContainerViewModel;
    public set filter(v: FilterAccessibleFormsViewModel) { this._filter = v; } public get filter(): FilterAccessibleFormsViewModel { return this._filter;} private _filter: FilterAccessibleFormsViewModel;
    public set loggedInPersonnelName(v: string) { this._loggedInPersonnelName = v; } public get loggedInPersonnelName(): string { return this._loggedInPersonnelName;} private _loggedInPersonnelName: string;
    public set loggedInPersonnelCode(v: string) { this._loggedInPersonnelCode = v; } public get loggedInPersonnelCode(): string { return this._loggedInPersonnelCode;} private _loggedInPersonnelCode: string;
    public set autohide(v: boolean) { this._autohide = v; } public get autohide(): boolean { return this._autohide;} private _autohide: boolean;
    public set themeWindow(v: ThemeSelectorViewModel) { this._themeWindow = v; } public get themeWindow(): ThemeSelectorViewModel { return this._themeWindow;} private _themeWindow: ThemeSelectorViewModel;
    public set shallShowThemes(v: boolean) { this._shallShowThemes = v; } public get shallShowThemes(): boolean { return this._shallShowThemes;} private _shallShowThemes: boolean;
    
    private async ShowMessageBox(message:ShowMessageBoxMessage){
        if (this.currentForm == undefined) 
        {

            let windowMessage =  new CreateWindowMessage("712830b8-3b83-4d49-af06-8686b3887f96");
            let window = await this.handleMessage(windowMessage);
            await new Promise((res) => setTimeout(() => res("p1"), 100));
            let oldResolveFunction = message.resolveFunction;
            message.resolveFunction = s => {
                (<WindowContainerViewModel>window).close();
                oldResolveFunction(s);
            }
            let result = await window.handleMessage(message);
            return result;
        }
        return this.currentForm.handleMessage(message);
    }
    private async addNewWindowFromMessage(message:CreateWindowMessage) : Promise<WindowContainerViewModel>{
        let windowContainer = new WindowContainerViewModel(this);
        let window = await new WindowFactory().getWindow(message,windowContainer);
        windowContainer.window = window;
        this.forms.push(windowContainer);
        this.currentForm = windowContainer;
        return windowContainer;
    }
    private async addNewWindowFromGeneraotrFunction(message:ShowWindowMessage) : Promise<WindowContainerViewModel>{
        let windowContainer = new WindowContainerViewModel(this);
        let window = message.generator(windowContainer);
        windowContainer.window = window;
        this.forms.push(windowContainer);
        this.currentForm = windowContainer;
        return windowContainer;
    }
    private closeWindow(window:WindowContainerViewModel){
        if(this.currentForm == window){
            let position = this.forms.indexOf(window);
            this.forms.remove(window);
            if(this.forms.length==0)
                this.currentForm = null;
            else if(this.forms.length>position){
                this.currentForm = this.forms[position];
            }else{
                this.currentForm = this.forms[this.forms.length-1];
            }
        }else{
            this.forms.remove(window)
        }
        
    }
    handleMessage(message : ViewModelMessage){
        if(message instanceof CreateWindowMessage){
            return this.addNewWindowFromMessage(message);
        }else if(message instanceof ShowWindowMessage){
            return this.addNewWindowFromGeneraotrFunction(message);
        }else if(message instanceof RequestCloseWindowMessage){
            this.closeWindow(message.window);
            return message.window;
        }else{
            return super.handleMessage(message);
        }
    }

    toggleAutohide() {
        this.autohide = !this.autohide;
    }
    showThemeWindow(){
        this.shallShowThemes = true;
        this.themeWindow = new ThemeSelectorViewModel(this);
    }
    closeThemeWindow(){
        this.shallShowThemes = false;
        this.themeWindow = null;
    }
    async logout(){
        let result = await this.messageBoxWarningYesNo('آیا برای خروج مطمئنید؟','خروج از برنامه');
        if (result == 'yes') {
            location.reload();
        }
    }
}

export class FilterAccessibleFormsViewModel extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.filteredAccessibleForms = ObservableArray.create<AccessibleFormViewModel>();
        this.accessibleForms = ObservableArray.create<AccessibleFormViewModel>();
        this.accessibleItems = new Map<string, AccessibleItem>();
        this.refresh();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set filteredAccessibleForms(v: ObservableArray<AccessibleFormViewModel>) { this._filteredAccessibleForms = v; } public get filteredAccessibleForms(): ObservableArray<AccessibleFormViewModel> { return this._filteredAccessibleForms;} private _filteredAccessibleForms: ObservableArray<AccessibleFormViewModel>;    
    public set accessibleForms(v: ObservableArray<AccessibleFormViewModel>) { this._accessibleForms = v; } public get accessibleForms(): ObservableArray<AccessibleFormViewModel> { return this._accessibleForms;} private _accessibleForms: ObservableArray<AccessibleFormViewModel>;
    public set writtenText(v: string) {
        this._writtenText = v;
        this.startFilter();
    } public get writtenText(): string { return this._writtenText;} private _writtenText: string;
    
    public set sideBarItems(v: SideBarItem[]) { this._sideBarItems = v; } public get sideBarItems(): SideBarItem[] { return this._sideBarItems;} private _sideBarItems: SideBarItem[];
    public set accessibleItems(v: Map<string, AccessibleItem>) { this._accessibleItems = v; } public get accessibleItems(): Map<string, AccessibleItem> { return this._accessibleItems;} private _accessibleItems: Map<string, AccessibleItem>;

    async refresh() {
        try{
            this.isLoading = true;
            let result = await ServerConnection.callServer('Complex/AuthorizationServices/GetAccessibleFormsForCurrentUser', {});
            let forms : AccessibleFormViewModel[] = result.Forms.map(x => {
                let r = new AccessibleFormViewModel(this);
                r.formId = x.Id;
                r.formName = x.Name;
                r.processFormId = x.ProcessFormId;
                r.processFormName = x.ProcessFormName;
                r.position = x.Position;
                return r;
            });
            let menu = new Menu();
            forms.forEach(x=>menu.addChild(x.formName.split('/'),x.position,x));
            menu.sort();
            forms = menu.getSortedData();
            this.accessibleForms.update(...forms);
            this.writtenText = "";
            this.filteredAccessibleForms.update(...this.accessibleForms);
            this.updateSideBarItems();
        }
        catch (ex) {
            console.log(ex);
        }         
        finally{
            this.isLoading = false;
        }
    }
    private timer:any;
    startFilter() {
        if(this.timer)
            clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.filteredAccessibleForms.update(...this.accessibleForms.filter(x => x.formName.includes(this.writtenText)));
            this.updateSideBarItems();
        }, 200);

    }

    updateSideBarItems()
    {
        this.accessibleItems.clear();
        let tempArray: SideBarItem[] = new Array();
        this.filteredAccessibleForms.forEach(element => {
            this.CreateAccessibleFormChains(element);
        });
        this.accessibleItems.forEach(element => {
            let sideBarItem = element.getCorrespondingSideBarItem();
            tempArray.push(sideBarItem);
        });
        this.sideBarItems = tempArray.slice();
    }

    CreateAccessibleFormChains(form: AccessibleFormViewModel){
        let parts: string[] = form.formName.split("/");
        let lastChainedItem: AccessibleItem = null;
        while (parts.length != 0){
            if (lastChainedItem == null){
                if (this.accessibleItems.has(parts[0])){
                    lastChainedItem = this.accessibleItems.get(parts[0]);
                    parts.splice(0, 1);
                    continue;
                }
                break;
            }
            else{
                if (lastChainedItem.hasChild(parts[0])){
                    let targetChild = lastChainedItem.getChild(parts[0]);
                    lastChainedItem = targetChild;
                    parts.splice(0, 1);
                    continue;
                }
                break;
            }
            
        }
        for (let index = 0; index < parts.length; index++) {
            let accessibleItem = new AccessibleItem();
            accessibleItem.name = parts[index];
            accessibleItem.iconClass = "";
            if (index == parts.length - 1){
                accessibleItem.accessibleForm = form;
            }
            if (index == 0 && lastChainedItem == null){
                this.accessibleItems.set(accessibleItem.name, accessibleItem);
                lastChainedItem = accessibleItem;
                continue;
            }
            lastChainedItem.children.push(accessibleItem);
            lastChainedItem = accessibleItem;
        }
    }
}

export class AccessibleFormViewModel extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set formName(v: string) { this._formName = v; } public get formName(): string { return this._formName;} private _formName: string;
    public set formId(v: string) { this._formId = v; } public get formId(): string { return this._formId;} private _formId: string;
    public set processFormId(v: string) { this._processFormId = v; } public get processFormId(): string { return this._processFormId;} private _processFormId: string;
    public set processFormName(v: string) { this._processFormName = v; } public get processFormName(): string { return this._processFormName;} private _processFormName: string;
    public set position(v: number) { this._position = v; } public get position(): number { return this._position;} private _position: number;
    
    select(){
        if(stringIsNullOrEmpty(this.processFormId)==false){
            let message = new CreateWindowMessage('5ec1473c-34a7-467a-9ec4-b039fa416a8c');
            message.isProcessForm = true;
            message.processFormId = this.processFormId;
            message.processFormName = this.formName.split('/').at(-1);
            this.handleMessage(message);
        }else{
            let message = new CreateWindowMessage(this.formId);
            this.handleMessage(message);

        }
    }
}


export class CreateWindowMessage extends ViewModelMessage{
    public windowId:string;
    public isProcessForm:boolean;
    public processFormId:string;
    public processFormName:string;

    constructor(windowId:string) {
        super();
        this.windowId = windowId;
    }
}
export class ShowWindowMessage extends ViewModelMessage{
    public generator:(parent:ViewModel)=>WindowViewModel;
    constructor(generator:(parent:ViewModel)=>WindowViewModel) {
        super();
        this.generator = generator;
    }
}

export class AccessibleItem{
    constructor() {
        this.children = ObservableArray.create<AccessibleItem>();
    }
    public name: string;
    public iconClass: string;
    public accessibleForm: AccessibleFormViewModel;
    public set children(v: ObservableArray<AccessibleItem>) { this._children = v; } public get children(): ObservableArray<AccessibleItem> { return this._children;} private _children: ObservableArray<AccessibleItem>;
    
    hasChild(key:string) : boolean {
        for (let index = 0; index < this.children.length; index++) {
            const child = this.children[index];
            if (child.name == key){
                return true;
            }
        }
        return false;
    }

    getChild(key:string): AccessibleItem {
        for (let index = 0; index < this.children.length; index++) {
            const child = this.children[index];
            if (child.name == key){
                return child;
            }
        }
        return null;
    }

    getCorrespondingSideBarItem() : SideBarElement {
        let element = new SideBarElement();
        element.name = this.name;
        element.iconClass = this.iconClass;
        element.command = this.accessibleForm ? () => {this.accessibleForm.select()} : () => {}
        if (this.children.length == 0) return element;
        element.childItems.push(...this.children.map(x => x.getCorrespondingSideBarItem()));
        return element;
    }
}

export class SideBarElement implements SideBarItem{
    name:string;
    iconClass:string;
    command:()=>void;
    childItems:SideBarItem[] = new Array();
}


class Menu{
    name:string;
    children:Menu[];
    relatedData : AccessibleFormViewModel;
    orderNo : number;
    constructor() {
        this.children = [];
    }

    addChild(name:string[],orderNo:number,data:AccessibleFormViewModel){
        let childName = name.shift();
        if(name.length==0){
            let newChild = new Menu();
            newChild.name = childName;
            newChild.orderNo = orderNo;
            newChild.relatedData = data;
            this.children.push(newChild);
        }else{
            let relatedChild = this.children.filter(x=>x.name == childName).at(0);
            if(relatedChild==null){
                let newChild = new Menu();
                newChild.name = childName;
                this.children.push(newChild);
                relatedChild = newChild;
            }
            relatedChild.addChild(name,orderNo,data);
        }
    }

    sort(){
        if(this.children.length>0){
            this.children.forEach(x=>x.sort());
            this.orderNo = this.children.reduce((a,c)=>a<c.orderNo ? a : c.orderNo,32000);
            this.children.sort((x,y)=>x.orderNo-y.orderNo);
        }
    }

    getSortedData():AccessibleFormViewModel[]{
        if(this.children.length==0){
            return [this.relatedData];
        }else{
            let result:AccessibleFormViewModel[] = [];
            this.children.forEach(x=>result.push(...x.getSortedData()));
            return result;
        }
    }
}